import useTableData from "../../../../state/table/UseTableData";

const useSelectAllIcon = (excludedIds) => {
  const { tableState, onUpdateSelectedIds } = useTableData();

  const onIconClicked = (e) => {
    e?.preventDefault();
    e?.stopPropagation();

    const newSelectedIds = tableState.selectedIds.length === (tableState.sortedData.length - excludedIds.length)
      ? []
      : tableState.sortedData.map(row => row[`${tableState.rowIdKey}`]);

    onUpdateSelectedIds(newSelectedIds.filter(id => !excludedIds.includes(id)));
  };

  return {
    tableHasData: tableState.sortedData.length > 0,
    areAllSelected: tableState.selectedIds.length === (tableState.sortedData.length - excludedIds.length),
    onIconClicked
  };
};

export default useSelectAllIcon;